module.exports = __webpack_public_path__ + "img/Game_target_Z-17.caf9f115.png";